import { FormProps } from "antd";

export const paymentFormLayout: Pick<
  FormProps,
  "labelCol" | "wrapperCol" | "labelAlign"
> = {
  wrapperCol: {
    xs: { span: 0 },
    md: { span: 8 },
    xl: { span: 6 },
    xxl: { span: 5 },
  },
  labelCol: {
    xs: { span: 0 },
    md: { span: 8 },
    xl: { span: 4 },
    xxl: { span: 3 },
  },
};
